<template>
  <v-container
    class="error-page fill-height"
    tag="section"
  >
    <v-row
      class="text-center"
      justify="center"
    >
      <v-card>
        <v-progress-linear
          class="ma-0"
          color="secondary"
          :indeterminate="loading"
        />
        <div
          v-if="message"
          class="text-h4 mb-6"
        >
          {{ message }}
        </div>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'PagesError',
    data: () => ({
      message: '',
      loading: false,
    }),
    mounted: function () {
      this.loading = true
      this.axios.post('/api/auth/confirmation/' + this.$route.query.key, {}).then(response => {
        this.loading = false
        if (!response.data.error) {
          this.message = 'E-mail успешно подтвержден. В течение 10 секунд вы будете перенаправлены в личный кабинет'
          const self = this
          setTimeout(function () {
            self.$router.push('/common/dashboard')
          }, 5000)
        } else {
          this.message = 'Произошла ошибка при валидации проверочного кода'
        }
      })
        .catch(e => {
          console.log(e)
          this.loading = false
          this.message = 'Произошла ошибка при валидации проверочного кода'
        })
    },
  }
</script>

<style lang="sass">
  .error-page
    h1
      font-size: 12rem
</style>
